import { FC, useState } from 'react';

import { useTranslate } from 'hooks/useTranslate';

import AnalyticsTabs from './components/AnalyticsTabs';
import CustomLandingTab from './tabs/CustomLandingTab';
import { AnalyticsTabId, analyticsTabs } from './constants/analyticsTabs';

type SocietyAnalyticsProps = {
  society: { _id?: string; name?: string } | null;
};

const renderActiveTab = (tabId: AnalyticsTabId, societyId?: string) => {
  if (tabId === 'customLanding') {
    return <CustomLandingTab societyId={societyId} />;
  }
  return null;
};

const SocietyAnalytics: FC<SocietyAnalyticsProps> = ({ society }) => {
  const { t } = useTranslate();
  const [activeTabId, setActiveTabId] = useState<AnalyticsTabId>(
    analyticsTabs[0].id
  );

  return (
    <div className="nk-block" data-testid="society-analytics">
      <div className="nk-block-head">
        <div className="nk-block-head-content">
          <h5 className="nk-block-title title">{t('Analytics')}</h5>
          <div className="nk-block-des">
            <p>{t('AnalyticsDescription')}</p>
          </div>
        </div>
      </div>

      <AnalyticsTabs
        tabs={analyticsTabs}
        activeTabId={activeTabId}
        onSelect={setActiveTabId}
      />

      {renderActiveTab(activeTabId, society?._id)}
    </div>
  );
};

export default SocietyAnalytics;
